import { PropsWithChildren } from 'react';

export const ListItem = ({ children }: PropsWithChildren) => {
  return (
    <li className="list-item pl-0" data-testid="li-markup">
      {children}
    </li>
  );
};
